import axios from 'axios';
import swal from 'sweetalert2';// import sweet alert

const perPage = 20;
const wceaStartYear = 2026;

const state = {
    user: {},
    basicProfile: {},
    accessToken: localStorage.getItem('access_token') || null,
    userId: null,
    userDataId: null,
    photo: null,
    locations: {},
    specializations: [],
    subSpecializations: [],
    userDocuments: {},
    uploadProgress: null,
    jurisdictions: [],
    perPage: perPage,
    dashbardInfo : {},
    notifications: {},
    hospitals: [],
    lastFetch: 0,
    lastFetch24: 0,
    wceaStartYear: wceaStartYear,
    preferredMethod: localStorage.getItem('method') || null
};

const getters = {
    basicProfile: state => state.basicProfile,
    user: state => state.user,
    getUserAccessToken: state => state.accessToken,
    getPreferredMethod: state => state.preferredMethod,
    locations: state => state.locations,
    specializations: state => state.specializations,
    subSpecializations: state => state.subSpecializations,    
    lock: state => (state.basicProfile.profile_lock == 'yes') ? true : false,
    jurisdictions: state => state.jurisdictions,
    isLoggedIn: state => state.accessToken !== null ? true : false,
    dashbardInfo: state => state.dashbardInfo,
    notifications: state => state.notifications,
    hospitals: state => state.hospitals,
    userPhoto: (state) => {
        const profile = state.basicProfile;
        return {
            has_file: (profile.photo !== null),
            file_name: profile.photo
        }
    },
    shouldUpdate: (state) => {
        const lastFetch = state.lastFetch;
        if (!lastFetch) return true; // Always fetch if never fetched
        const fiveMinutes = 5 * 60 * 1000;
        return (Date.now() - lastFetch) > fiveMinutes;
    },
    shouldUpdate24: (state) => {
        const lastFetch24 = state.lastFetch24;    
        if (!lastFetch24) return true; // Always fetch if never fetched
        const twentyFourHours = 24 * 60 * 60 * 1000; 
        return (Date.now() - lastFetch24) > twentyFourHours;
    },
    userPhotoUrl: state => state.user.url+'/photo/',
    cpdPointUrl: state => state.user.url+'/documents/cpd/',
    docPhoto: state => state.photo,
    fullname: (state) => {
        let profile = state.basicProfile;
        let name = profile.first_name + ' ';
        name += profile.last_name;
        return name.toLowerCase();
    }
};

const actions = {
    async updateUserProfile({ state, getters, rootState, commit }, status = false) {// fetch profile only not cached 
        if (!getters.shouldUpdate && ! status) {
            // console.log("Using cached products.");
            return state.user; // Exit early if the cache is still fresh
        }
        // console.log("updating from server");
        try {
            const url = rootState.url.profileUserUrl;
            const header = {Authorization: `Bearer ${state.accessToken}`};
            const response = await axios.post(url, {}, { headers: header });// make api call
            const res = response.data.data;// response data
            commit('setUserProfile', res.basic_profile);
            commit('setUser', res.user);
            commit('setDashboardInfo', res.dashboard_info);// set dashboard info
            commit('setLocations', res.locations); // set locations
            commit('setPhoto', res.photo); // set photo
            return res.user;
        } catch (error) {
            swal.fire("Session Expired!", "Your session has expired please log in again to continue", "warning");
            localStorage.removeItem('access_token');// remove token
            localStorage.removeItem('time_out');// remove time out
            state.accessToken = null;
            return setTimeout(() => { window.location.href = '/'; }, 2000);// redirect to login
        }
    },
    async fetchUserProfile(state) {// fetch user profile
        const url = state.rootState.url.profileUserUrl;
        const header = {Authorization: `Bearer ${state.accessToken}`};
        const response = await axios.post(url, {'id' : state.state.userId}, { headers: header });// make api call
        const res = response.data.data;// response data
        state.commit('setUserProfile', res.basic_profile);
        state.commit('setUser', res.user);
        state.commit('setDashboardInfo', res.dashboard_info);// set dashboard info
        state.commit('setLocations', res.locations); // set locations
        return res.user;
    },
    async getSpecializations({ getters, rootState, commit }) {// fetch profile only not cached         
        if (!getters.shouldUpdate24) {
            return; // Exit early if the cache is still fresh
        }
        try {
            const url = rootState.url.specializationsUrl;
            const header = {Authorization: `Bearer ${state.accessToken}`};
            const response = await axios.post(url,{}, { headers: header });// make api call
            commit('setSpecializations', response.data);
            commit('setSubSpecializations', response.data);   
            commit('setSubSpecializations', response.data);
            commit('setHospitals', response.data);          
            return response.data;
        } catch (error) {
            console.error('API fetch failed:', error);
        }
    }, 
    async getUserDocuments({ state, getters, rootState, commit }, regId) {// fetch profile only not cached         
        if (!getters.shouldUpdate24) {
            return; // Exit early if the cache is still fresh
        }
        try {
            const url = rootState.url.getUserDocumentsUrl;
            const header = {Authorization: `Bearer ${state.accessToken}`};
            const response = await axios.post(url, {'id' : state.userId,
                            'reg_id' : regId }, { headers: header });// make api call
            commit('setUserDocuments', response.data);// set user profile function
        return response.data;
        } catch (error) {
            console.error('API fetch failed:', error);
        }
    },
    destroyAccessToken(state) {// destroy local storage
        localStorage.removeItem('access_token');// remove token
        localStorage.removeItem('time_out');// remove time out
        state.accessToken = null;
        return setTimeout(() => { window.location.href = '/'; }, 2000);// redirect to login
    },
    storeAndLoginUser(state, data) {//set token and login user
        let hours = 2;
        localStorage.setItem('access_token', data.access_token);// set access token
        localStorage.setItem('method', data.preferred_method);// set access token
        localStorage.setItem('time_out', new Date().getTime() + (hours * 60 * 60 * 1000));// set timeout
    },
    async getBasicProfile(state) {// fetch user profile function
        const url = state.rootState.url.profileUserUrl;
        const header = {Authorization: `Bearer ${state.accessToken}`};
        const response = await axios.post(url, {'id' : state.state.userId},
                        { headers: header });// make api call
        return response.data.basic_profile;
    },
    async getLocations(state) {// fetch locations (states, lgas, and countries)
        const url = state.rootState.url.locationsUrl;
        const header = {Authorization: `Bearer ${state.accessToken}`};
        const response = await axios.post(url,{}, { headers: header });// make api call
        state.commit('setLocations', response.data);
        return response.data;
    },
    async editUserProfile(state, data) {// fetch user profile
        const url = state.rootState.url.editUserProfileUrl;
        const header = {Authorization: `Bearer ${state.state.accessToken}`};
        const response = await axios.post(url, {data}, { headers: header });// make api call
        state.commit('setUserProfile', response.data);// set user profile function
        return response.data;
    },    
    async UpdateUserWorkProfile(state, data) {// fetch user profile
        const url = state.rootState.url.updateUserWorkUrl;
        const header = {Authorization: `Bearer ${state.state.accessToken}`};
        const response = await axios.post(url, {data}, { headers: header });// make api call
        return response.data;
    },
    async uploadUserDocuments(state, data) {// upload user documents
        const url = state.rootState.url.uploadUserDocumentsUrl;
        const header = {Authorization: `Bearer ${state.state.accessToken}`};
        let response = await axios.post(url, {data}, {
            headers: header,
            onUploadProgress: uploadEvent => {
                state.state.uploadProgress = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
            }
        });// make api call
        return response.data;
    },
    async uploadUserPhoto(state, data) {// upload user documents
        const url = state.rootState.url.uploadUserPhotoUrl;
        const header = {Authorization: `Bearer ${state.state.accessToken}`};
        let response = await axios.post(url, {data}, {
            headers: header,
            onUploadProgress: uploadEvent => {
                state.state.uploadProgress = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
            }
        });// make api call
        return response.data;
    },
    updatePhotoName({ commit }, fileName) {// update photo name
        commit('setUpdatePhotoName', fileName);// set update photo function
    },
    async saveJurisdictions(state, data) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.saveJurisdictionsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {data}, { headers: header});// make api call
        return response.data;
    },
    async removeJurisdiction(state, data) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.removeJurisdictionUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {data}, { headers: header});// make api call
        return response.data;
    },
    async saveReferees(state, data) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.saveRefereesUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {data}, { headers: header});// make api call
        return response.data;
    },
    async removeReferee(state, data) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.removeRefereeUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {data}, { headers: header});// make api call
        return response.data;
    },
    async updateUserAdditionalRecords(state, data) {// update user additional records
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.updateAdditionalRecordsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {data}, { headers: header });// make api call
        return response.data;
    },
    async getUserAdditionalRecords(state, data) {// get user additional records
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAdditionalRecordsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {data}, { headers: header});// make api call
        return response.data;
    },
    async getUpdateProfileInfo(state) {// get user additional records
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getUpdateProfileInfoUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {'id' : state.state.userId}, { headers: header});// make api call
        return response.data;
    },
    async getRegistrationTypes(state) {// get user additional records
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getRegistrationTypesUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {}, { headers: header});// make api call
        return response.data;
    },
    async getUserSubRegistrationTypes(state) {// get user additional records
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getSubRegistrationTypesUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {}, { headers: header});// make api call
        return response.data;
    },
    async getDashboardInfo(state) {// fetch user profile
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getDashboardInfoUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, {'id' : state.state.userId},
                        { headers: header });// make api call
        state.commit('setDashboardInfo', response.data);
    },
    async changePassword(state, data) {// get user additional records
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.changePasswordUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {data}, { headers: header});// make api call
        return response.data;
    },
    async getUserPhoto(state) {// fetch user profile function
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getUserPhotoUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, {'id' : state.state.userId},
                        { headers: header });// make api call
        return response.data;
    },
    async getUserCertificates(state, limit) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getUserCertificatesUrl;
        const id = state.rootState.user.userId;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {id : id, limit : limit}, { headers: header});// make api call
        return response.data;
    },
    async disableProfile(state) {// fetch user profile
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.disableProfileUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, {'id' : state.state.userDataId},
                { headers: header });// make api call
        return response.data;
    },
    async validatingFolio(state, folio) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.validatingFolioUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {'folio_number' : folio}, { headers: header});// make api call
        return response.data;
    },
    async getDoctorStatusProfile(state, data) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getDoctorStatusProfileUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async getUserNotifications(state, limit) {// fetch user profile
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getUserNotificationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { id : state.state.userDataId, limit : limit }, { headers: header });// make api call
        state.commit('setUserNotifications', response.data);
        return response.data;
    },
    async deleteUserNotification(state, id) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.deleteUserNotificationUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {'id' : id}, { headers: header});// make api call
        return response.data;
    },
    async getUserNotification(state, slug) {// fetch user profile
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getUserNotificationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { id : state.state.userDataId, slug : slug }, { headers: header });// make api call
        return response.data;
    },
    async verifyRecaptcha(state, data) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.verifyRecaptchaUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async getHospitals(state) {// fetch Hospitals 
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getHospitalsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url,{}, { headers: header });// make api call
        state.commit('setHospitals', response.data);
        return response.data;
    },
    async getUserPendingUploads(state) {// save user Jurisdiction
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getUserPendingUploadsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {id : state.state.userId}, { headers: header});// make api call
        return response.data;
    },
    async viewUserDocument(state, filename) {// fetch user document function
        const url = state.rootState.url.documentViewUrl;
        const header = {Authorization: `Bearer ${state.state.accessToken}`};
        try {
            const response = await axios.post(url, 
                        { filename: filename },
                        { responseType: 'blob', headers: header });// make api call
            const blobUrl = URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
            );

            window.open(blobUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
            return blobUrl;
        } catch (error) {
            swal.fire("Error!", "Unable to view document", "error");
        }
    },
};

const mutations = {
    setUserProfile(state, userData) {// set user basic profile only
        state.basicProfile = userData;
        state.userDataId = userData.id;
        state.lastFetch = Date.now(); // Update the timestamp
    },
    // setUserProfile: (state, userData) => (state.basicProfile = userData),// set user basic profile only
    setUser(state, user) {// set user profile
        state.user = user;
        state.userId = user.id;
    },
    setLocations: (state, data) => (state.locations = data),// set locations (states, lgas, and countries)
    setSpecializations: (state, data) => (state.specializations = data.specializations),// set specializations
    setSubSpecializations: (state, data) => (state.subSpecializations = data.sub_specializations),// set specializations
    setUserDocuments: (state, data) => (state.userDocuments = data),// set user documents
    setUpdatePhotoName: (state, fileName) => (state.basicProfile.photo = fileName),// set user basic profile only
    setDashboardInfo: (state, data) => (state.dashbardInfo = data),// set user profile
    setUserNotifications(state, data) {// set user notifications
        state.notifications.records = data.notifications.data;
        state.notifications.total = data.total;
    },
    setHospitals: (state, data) => {
        let hospitals = data.hospitals;
        let other = { id : 0, name: 'Others (Specify)'};
        hospitals.push(other);
        state.hospitals = hospitals;
    },// set hospitals
    setPhoto: (state, data) => (state.photo = data),// set photo 
};

export default {
    state,
    getters,
    actions,
    mutations
}